import { render } from "./PaymentOption.vue?vue&type=template&id=667ea78a&scoped=true"
import script from "./PaymentOption.vue?vue&type=script&lang=js"
export * from "./PaymentOption.vue?vue&type=script&lang=js"

import "./PaymentOption.vue?vue&type=style&index=0&id=667ea78a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667ea78a"]])

export default __exports__